/* eslint-disable @typescript-eslint/no-explicit-any */
import { StateCreator } from 'zustand';
import { createAppStore } from '@marriott/mi-store-utils';

export type InventoryDateFetchStatus = 'idle' | 'loading' | 'loaded' | 'error';

export interface InventoryDateState {
  singleDateLimit: string | null;
  groupDateLimit: string | null;
  fetchStatus: InventoryDateFetchStatus;
}

export interface InventoryDateActions {
  initializeFromSession: (sessionData: any) => void;
  setInventoryDates: (singleDateLimit: string, groupDateLimit: string) => void;
  setFetchStatus: (status: InventoryDateFetchStatus) => void;
  reset: () => void;
}

export type InventoryDateStore = InventoryDateState & InventoryDateActions;

const initialState: InventoryDateState = {
  singleDateLimit: null,
  groupDateLimit: null,
  fetchStatus: 'idle',
};

const inventoryDateStoreCreator: StateCreator<InventoryDateStore> = set => ({
  ...initialState,

  initializeFromSession: (sessionData: any) => {
    const ariesCommon = sessionData?.cacheData?.data?.AriesCommon ?? sessionData?.data?.AriesCommon;
    const singleDateLimit = ariesCommon?.singleDateLimit;
    const groupDateLimit = ariesCommon?.groupDateLimit;
    if (singleDateLimit) {
      set({
        singleDateLimit,
        groupDateLimit: groupDateLimit ?? null,
        fetchStatus: 'loaded',
      });
    }
  },

  setInventoryDates: (singleDateLimit: string, groupDateLimit: string) => {
    set({
      singleDateLimit,
      groupDateLimit,
      fetchStatus: 'loaded',
    });
  },

  setFetchStatus: (status: InventoryDateFetchStatus) => {
    set({ fetchStatus: status });
  },

  reset: () => {
    set({ ...initialState });
  },
});

export const useInventoryDateStore = createAppStore(inventoryDateStoreCreator, {
  usePersistentStore: false,
});
